import AREAS from './areas'
import CATEGORIA from './categoria'
import PRIORIDAD from './prioridad'

export class CalificacionCursoNotification {
  #notification

  constructor(notification) {
    this.#notification = notification
  }

  create(args) {
    const notification = new this.#notification()
    notification.responsable = args.responsable
    notification.afectado = args.afectado
    notification.titulo = AREAS.IFCSP + ': Calificación del curso'
    notification.mensaje = `El Elemento ${args.nombreEvaluador} calificó con ${args.calificacion} al Elemento ${args.nombreEvaluado} en el curso ${args.nombreCurso}.`
    notification.prioridad = PRIORIDAD.MEDIA
    notification.categoria = CATEGORIA.INFORMATIVA

    return notification
  }
}
